module.exports = __webpack_public_path__ + "img/p1-desc@2x.15c21a2f.jpg";